import React from "react"

import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Layout from '../components/Layout'
import Paper from '@material-ui/core/Paper'
import SEO from "../components/SEO"
import {handleLocation, isValidLocation, getCurrentLocation} from '../utils/checkValidLocation';
import {LinearProgress} from '@material-ui/core'
import Shutdown from '../components/Shutdown'

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(9),
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: 10,
    padding: theme.spacing(3)
  },

  header: {
    margin: theme.spacing(3, 0, 2),
    textAlign: 'center'
  },

  section: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function ContactUs() {
  const classes = useStyles();
  const [location, setLocation] = React.useState(null)
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let currentOrigin = window?.location?.origin || 'vusiem'
    if (currentOrigin.toLowerCase().includes('vusiem')||currentOrigin.toLowerCase().includes('museum-buddy')) {
    let currentLocation = getCurrentLocation()
    if (currentLocation?.location) {
      setLocation(currentLocation.location);
      setLoading(false);
    } else {
    var requestOptions = {
      method: 'GET',
    };
    
    fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=3db745ec903945059d33e698d06ffd17", requestOptions)
      .then(response => response.json())
      .then(result => {handleLocation({locationCode: result?.country?.iso_code}); 
      if (result?.country?.iso_code !== 'DE') {setLocation(result?.country?.iso_code)}; 
      setLoading(false)})
      .catch(error => {console.log('error', error); handleLocation({locationCode: 'US'}); setLocation('US'); setLoading(false)});

    }} else {setLocation('US'); setLoading(false)}
  }, []);


  return (
    loading? <LinearProgress />:(
    location ?<Layout>
      <SEO title="Museum Buddy Privacy Policy" description={'We take Data privacy and customer information confidentiality seriously'}/>
    <Container component="main" maxWidth="md">
      <CssBaseline />

      <Paper elevation={10} className={classes.paper}>
        <div style={{justifyContent:'center'}}>
        <Typography component="h1" variant="h4" className={classes.header}>
          Privacy Policy
        </Typography>
        <Typography variant="caption" style={{marginTop: -5}}>
        Effective date: October 04, 2018
        </Typography>
        <Typography variant='body2' className={classes.section}>

Museum Tour Guides Ltd (“us”, “we”, or “our”) operates the website and the Museum Buddy mobile applications (the “Service”). <br/>

This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. .
<br/>
We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
<br/>
  </Typography>
    <Typography variant='h6' className={classes.section}> Information Collection And Use</Typography>
We collect several different types of information for various purposes to provide and improve our Service to you.<br/>
<Typography variant='h5' className={classes.section}> Types of Data Collected</Typography>
<Typography variant='subtitle1' className={classes.section}> Personal Data</Typography>
While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:
<br/>
<ul><li>Cookies and Usage Data</li></ul>
<Typography variant='subtitle1' className={classes.section}> Usage Data</Typography>
<br/>
We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device (“Usage Data”).
<br/>
This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
<br/>
When you access the Service by or through a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
<br/>
<Typography variant='subtitle1' className={classes.section}> Tracking &amp; Cookies Data</Typography>
<br/>
We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
<br/>
Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.
<br/>
You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
<br/>
Examples of Cookies we use:
<ul>
<li> <span style={{fontWeight: 'bold'}}>Session Cookies.</span> We use Session Cookies to operate our Service.</li>
<li> <span style={{fontWeight: 'bold'}}>Preference Cookies.</span> We use Preference Cookies to remember your preferences and various settings.</li>
<li> <span style={{fontWeight: 'bold'}}>Security Cookies.</span> We use Security Cookies for security purposes.</li>
</ul>
<Typography variant='h6' className={classes.section}> Use of Data</Typography>

Museum Tour Guides Ltd uses the collected data for various purposes:
<ul>
<li> To provide and maintain the Service</li>
<li> To notify you about changes to our Service</li>
<li> To allow you to participate in interactive features of our Service when you choose to do so</li>
<li> To provide customer care and support</li>
<li> To provide analysis or valuable information so that we can improve the Service</li>
<li> To monitor the usage of the Service</li>
<li> To detect, prevent and address technical issues</li>
</ul>
<Typography variant='h6' className={classes.section}> Transfer Of Data</Typography>


Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.

If you are located outside United Kingdom and choose to provide information to us, please note that we transfer the data, including Personal Data, to United Kingdom and process it there.

Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

Museum Tour Guides Ltd will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.

<Typography variant='h6' className={classes.section}> Disclosure Of Data</Typography>
<Typography variant='h5' className={classes.section}> Legal Requirements</Typography>

Museum Tour Guides Ltd may disclose your Personal Data in the good faith belief that such action is necessary to:
<ul>
<li> To comply with a legal obligation</li>
<li> To protect and defend the rights or property of Museum Tour Guides Ltd</li>
<li> To prevent or investigate possible wrongdoing in connection with the Service</li>
<li> To protect the personal safety of users of the Service or the public</li>
<li> To protect against legal liability</li>
</ul>
<Typography variant='h6' className={classes.section}> Security Of Data</Typography>

The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

<Typography variant='h6' className={classes.section}> Service Providers</Typography>

We may employ third party companies and individuals to facilitate our Service (“Service Providers”), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.

These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
<Typography variant='h6' className={classes.section}> Links To Other Sites</Typography>

Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.

We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
<Typography variant='h6' className={classes.section}> Children’s Privacy</Typography>

Our Service does not address anyone under the age of 18 (“Children”).

We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.
<Typography variant='h6' className={classes.section}>Changes To This Privacy Policy</Typography>


We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.

We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the “effective date” at the top of this Privacy Policy.

You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
<Typography variant='h6' className={classes.section}>Contact Us</Typography>

If you have any questions about this Privacy Policy, please contact us:
<ul><li>
- By email: info(@)museum-buddy.com
</li></ul>
or click on Contact Us button below.<br/>
        </div>

        </Paper>
    </Container>
  </Layout>: <Shutdown />)
  );
}
